var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDhlLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logo",
    xmlns: "http://www.w3.org/2000/svg",
    width: 160,
    height: 50,
    viewBox: "0 0 160 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "brand_dhl-logo_1-base-unit-safe-space_size-8x16_background",
    "data-name": "brand/dhl-logo/1-base-unit-safe-space/size-8x16 background",
    width: 160,
    height: 50,
    fill: "#fc0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dhl-logo-box",
    transform: "translate(16 16)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "brand_dhl-logo_postyellow-box_size-8x16_background",
    "data-name": "brand/dhl-logo/postyellow-box/size-8x16 background",
    width: 128,
    height: 18,
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "dhl_logo",
    "data-name": "dhl/logo",
    transform: "translate(0 0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "official_dhllogo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined_Shape",
    "data-name": "Combined Shape",
    d: "M16.732,16.735,24.94,6.414H35.133c1.128,0,1.128.382.541,1.1-.541.68-1.488,1.912-2.075,2.634-.271.382-.812,1.019.9,1.019h13.62a14.415,14.415,0,0,1-11.41,5.606C31.39,16.735,16.732,16.735,16.732,16.735Zm92.14,0,.947-1.189h18.04v1.189Zm-20.972,0c-4.826,0-6.134-2.166-4.645-3.993.406-.51,1.263-1.614,1.263-1.614h26.7l-4.465,5.606Zm-23.407,0,4.465-5.606H80.685L76.22,16.735Zm-16.958,0L52,11.128H63.727l-4.465,5.606ZM0,16.735V15.545H15.515l-.9,1.189Zm110.632-2.209.947-1.189H127.86v1.189ZM0,14.526V13.337H17.273l-.947,1.189Zm112.391-2.209.947-1.189H127.86v1.189ZM0,12.317V11.128H19.032l-.947,1.189ZM40.049,9.9c-1.714,0-1.173-.68-.9-1.019.586-.722,1.534-1.954,2.075-2.633.587-.722.587-1.1-.541-1.1H18.4L22.505,0S40.681,0,46.048.042C52,.042,53.534,4.417,51.865,6.5L49.16,9.9Zm45.461-.042L93.358,0h12.448L97.958,9.854Zm-32.518,0L60.84,0H72.567L68.1,5.649h5.232L77.843,0H89.57L81.722,9.854Z",
    fill: "#d40511"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDhlLogo);
export default __webpack_public_path__ + "static/media/dhlLogo.6de8dcc20558f70b84a43c0a88cfe007.svg";
export { ForwardRef as ReactComponent };